// Ticks a set of [data-unit] tiles down to the ISO date in data-end, then reveals the ended message.
class SCountdown extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.tiles = this.querySelector('[data-countdown-tiles]');
    this.ended = this.querySelector('[data-countdown-ended]');
    if (Number.isNaN(this.end)) return;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = Math.max(0, this.end - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      if (el) el.textContent = String(values[unit]).padStart(2, '0');
    }
    if (remaining === 0) {
      clearInterval(this.timer);
      if (this.tiles) this.tiles.hidden = true;
      if (this.ended) this.ended.hidden = false;
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
